import { render, staticRenderFns } from "./BaseOrderCheckoutLayout.vue?vue&type=template&id=405e57a8&scoped=true&"
import script from "./BaseOrderCheckoutLayout.vue?vue&type=script&lang=ts&"
export * from "./BaseOrderCheckoutLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e57a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('405e57a8')) {
      api.createRecord('405e57a8', component.options)
    } else {
      api.reload('405e57a8', component.options)
    }
    module.hot.accept("./BaseOrderCheckoutLayout.vue?vue&type=template&id=405e57a8&scoped=true&", function () {
      api.rerender('405e57a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/view/app/BaseOrderCheckoutLayout.vue"
export default component.exports